import { Journey as API } from '@src/api/types';
import { baseURL } from '@src/configuration/constants';
import { Journey as Data } from '@src/types';

const Factory = (api: API): Data => ({
  id: api.id,
  title: api.title,
  cover: {
    uri: `${baseURL}/media/v1/image/${api.cover}`,
  },
  avatar: api.owner.profilePicture
    ? api.owner.profilePicture.startsWith('http')
      ? {
          uri: api.owner.profilePicture,
        }
      : {
          uri: `${baseURL}/media/v1/image/${api.owner.profilePicture}`,
        }
    : undefined,
});

export default Factory;
